/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Pick_HeadingInputs */

const en_onboarding_v1_pick_heading = /** @type {(inputs: Onboarding_V1_Pick_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here’s where we’d start you`)
};

const de_onboarding_v1_pick_heading = /** @type {(inputs: Onboarding_V1_Pick_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier würden wir mit Ihnen starten`)
};

const pt_br2_onboarding_v1_pick_heading = /** @type {(inputs: Onboarding_V1_Pick_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É por aqui que começaríamos`)
};

const tr_onboarding_v1_pick_heading = /** @type {(inputs: Onboarding_V1_Pick_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlangıç için önerimiz`)
};

const zh_cn2_onboarding_v1_pick_heading = /** @type {(inputs: Onboarding_V1_Pick_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我们建议您从这里开始`)
};

const zh_hk2_onboarding_v1_pick_heading = /** @type {(inputs: Onboarding_V1_Pick_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我們建議您由這裡開始`)
};

const ko_kr2_onboarding_v1_pick_heading = /** @type {(inputs: Onboarding_V1_Pick_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여기서 시작하는 것을 추천드려요`)
};

const ru_ru2_onboarding_v1_pick_heading = /** @type {(inputs: Onboarding_V1_Pick_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вот с чего мы рекомендуем вам начать`)
};

const es_419_onboarding_v1_pick_heading = /** @type {(inputs: Onboarding_V1_Pick_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este es el punto de partida que recomendamos`)
};

/**
* | output |
* | --- |
* | "Here’s where we’d start you" |
*
* @param {Onboarding_V1_Pick_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_pick_heading = /** @type {((inputs?: Onboarding_V1_Pick_HeadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Pick_HeadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_pick_heading(inputs)
	if (locale === "de") return de_onboarding_v1_pick_heading(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_pick_heading(inputs)
	if (locale === "tr") return tr_onboarding_v1_pick_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_pick_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_pick_heading(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_pick_heading(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_pick_heading(inputs)
	return es_419_onboarding_v1_pick_heading(inputs)
});